define([
    "view-sizeGuide",
    "domReady",
    "jquery"
], function (ViewSizeGuide, domReady, $) {

    "use strict";

    // Global requires
    domReady(function(){
    	console.log('init size guide');
        new ViewSizeGuide({el: $('.page-sections')});
    });

});
